import { Injectable } from '@angular/core';
import { EnvironmentSettings } from '../models/environmentsettings.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { PartGroup } from '../../opc-app/partgroup/partgroup.model';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';


@Injectable()
export class PartGroupService {
  private sharedValueSource = new BehaviorSubject<string>('default');
  private sharedPageValue = new BehaviorSubject<boolean>(false);
  private sharedBackButton = new BehaviorSubject<boolean>(false);
  sharedValue$ = this.sharedValueSource.asObservable();
  sharedPageValue$ = this.sharedPageValue.asObservable();
  sharedBackButtonValue$ = this.sharedBackButton.asObservable();
  addIndex: boolean = true;
  environmentSettings: EnvironmentSettings;

  constructor(private _http: HttpClient, private router: Router) {
    this.environmentSettings = new EnvironmentSettings();

  }

  forceNavigate(path: string) {
    if (this.router.url === path) {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigateByUrl(path);
    }
  }

  getPartGroupByCategoryId(plid: number, pcid: number): Observable<any> {
    return this._http.get(this.environmentSettings.apiEndPoint + 'api/partgroup/GetPartGroups/' + plid + '/' + pcid);
  }

  // To get parts by filtered character
  getPartsByCharacter(partNumber: string): Observable<any> {
    const url = this._http.get(this.environmentSettings.apiEndPoint + 'api/partgroup/GetPartsByCharacter/' + encodeURIComponent(partNumber));
    return url;
  }

  getAllPartGroups(): Observable<any> {
    return this._http.get(this.environmentSettings.apiEndPoint + 'api/partgroup/GetAllPartGroups');
  }

  setSharedValue(value: string) {
    this.sharedValueSource.next(value);
  }

  setSharedPageValue(value: boolean) {
    this.sharedPageValue.next(value);
  }

  setSharedBackButtonValue(value: boolean) {
    this.sharedBackButton.next(value);
  }

  addOrUpdatePartGroup(partGroup: PartGroup, file: any, isNew: boolean): Observable<any> {

    let urlPath = '';
    if (isNew) {
      urlPath = 'api/partgroup/AddPartGroup';
    } else {
      urlPath = 'api/partgroup/UpdatePartGroup';
    }
    const data = JSON.stringify(partGroup);
    const formData = new FormData();
    formData.append('partgroup', data);
    if (file) {
      formData.append('file', file, file.name);
    }
    return this._http.post(this.environmentSettings.apiEndPoint + urlPath, formData);
  }
  deletePartGroup(item: number): Observable<any> {
    return this._http.post(this.environmentSettings.apiEndPoint + 'api/partgroup/DeletePartGroup', item);
  }
}



// WEBPACK FOOTER //
// ./src/opc/shared/services/partgroup.service.ts